import { createPromiseEvaluatedToComponentProps } from './AudiencePreviewWidgetUtils';

// PHOB-1857: unified TV shows one preview bar with two source rows (ACR/hisense, Streaming/peerlogix).
// Both source demographics calls are fanned out under a single promise so the wrapping Widget renders
// exactly one spinner until both settle. A source that rejects (or is cancelled) degrades to an
// empty row rather than blanking the whole bar.
export async function createUnifiedPromiseEvaluatedToComponentProps(
  sources,
  audienceSegment,
  userId,
  audienceDistributionService,
  isRequestCancelledService,
  trackTooNarrow,
  hideAudiencePreview,
  householdDistributionService,
  showAudienceIpCount
) {
  const results = await Promise.all(
    sources.map(async (source) => {
      const identity = {
        sourceValue: source.value,
        sourceLabel: source.label,
        sourceColorClass: source.colorClass,
      };
      try {
        const props = await createPromiseEvaluatedToComponentProps(
          audienceSegment,
          source.value,
          userId,
          audienceDistributionService,
          isRequestCancelledService,
          trackTooNarrow,
          hideAudiencePreview,
          householdDistributionService,
          showAudienceIpCount
        );
        // createPromiseEvaluatedToComponentProps returns `false` on a cancelled request.
        return { ...identity, hasData: false, ...(props || {}) };
      } catch (e) {
        return { ...identity, hasData: false, isError: true };
      }
    })
  );

  return { sources: results, hasData: results.some((r) => r.hasData) };
}
